// extracted by mini-css-extract-plugin
export var arrowRight = "ComponentActivityCards-module--arrowRight--b2720";
export var card = "ComponentActivityCards-module--card--8c6b4";
export var cardGrid = "ComponentActivityCards-module--cardGrid--ffd62";
export var fixed = "ComponentActivityCards-module--fixed--85495";
export var richText = "ComponentActivityCards-module--richText--3129a";
export var section = "ComponentActivityCards-module--section--3699f";